
import { defineComponent, ref } from 'vue';
import _ from 'lodash';

import ESARSite from '@/models/ESARSite';

import Section from './Section.vue';
import Basics from './Basics.vue';
import SiteInformation from './SiteInformation.vue';
import ContaminationDetails from './ContaminationDetails.vue';
import RemediationSystem from './RemediationSystem.vue';
import RiskManagement from './RiskManagement.vue';
import GroundwaterAndSoilGrainSize from './GroundwaterAndSoilGrainSize.vue';

type SectionName = 'site-information' | 'contamination-details' | 'remediation-system' | 'risk-management' | 'groundwater-&-soil-grain-size';
type Sections = {
    'site-information': boolean,
    'contamination-details': boolean,
    'remediation-system': boolean,
    'risk-management': boolean,
    'groundwater-&-soil-grain-size': boolean,
}

export default defineComponent({
    name: 'Details',
    components: {
        Section,
        Basics,
        SiteInformation,
        ContaminationDetails,
        RemediationSystem,
        RiskManagement,
        GroundwaterAndSoilGrainSize
    },
    props: {
        siteDetails: ESARSite
    },
    setup(props) {
        const sections = {
            'site-information': false,
            'contamination-details': false,
            'remediation-system': false,
            'risk-management': false,
            'groundwater-&-soil-grain-size': false,
        };

        const sectionsExpanded = ref<Sections>(sections);

        const isAllExpandable = ref<boolean>(true);

        const isExpanded = (s: SectionName) => sectionsExpanded.value[s];

        const setIsAllExpandable = () => {
            isAllExpandable.value = _.values(sectionsExpanded.value).some((i) => i === false);
        };

        const toggleSection = (s: SectionName) => {
            sectionsExpanded.value[s] = !sectionsExpanded.value[s];
            setIsAllExpandable();
        };

        const toggleAllSections = (e: Event) => {
            e.preventDefault();
            _.keys(sectionsExpanded.value).forEach((k) => {
                sectionsExpanded.value[k as SectionName] = isAllExpandable.value;
            });
            setIsAllExpandable();
            return false;
        };

        return {
            isAllExpandable,
            isExpanded,
            toggleSection,
            toggleAllSections,
        };
    }
});
